import { hasYesOrNo } from 'models/validate';
import militaryDisciplineItemValidator from 'forms/sections/military/disciplinary/validators/item';
import { ValidateJSModel } from 'forms/shared/types';
import { MilitaryDisciplinaryProceduresModel } from './types';

const militaryDisciplinaryProceduresValidator: ValidateJSModel<MilitaryDisciplinaryProceduresModel> = {
  HasDisciplinary: (value, attributes, attributeName, options) => {
    if (options?.militaryHasServed) {
      return {
        presence: true,
        hasValue: { validator: hasYesOrNo },
      };
    }

    return {};
  },

  List: (value, attributes) => {
    if (attributes?.HasDisciplinary?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: militaryDisciplineItemValidator },
      };
    }

    return {};
  },
  Comments: {},
  SummaryComments: {},
};

export default militaryDisciplinaryProceduresValidator;
